module.exports = __webpack_public_path__ + "media/images/monthly15-4defe82a714c75f1c33d23f4052d3569.jpg";